import utility from './utility'

const withdrawFunds = {
    init: function () {
        [...document.querySelectorAll("#account--withdraw")].map(withdrawForm => {
            new this.withdrawActions(withdrawForm);
        });   
        this.resultExpandClick();
    },

    withdrawActions: class {
        constructor(withdrawForm) {
            this.otherLabel = withdrawForm.querySelector('.choose-plays .input-other');
            this.otherInput = withdrawForm.querySelector('.choose-plays .input-other input');
            if (this.otherLabel) {
                [...withdrawForm.querySelectorAll('.choose-plays input[type="radio"]')].map(option => {
                    option.onclick = () => {
                        this.detectValue(option);
                    }
                });
            }

            this.withdrawForm = withdrawForm;         
            this.submitButtons = [...document.querySelectorAll('#account--withdraw #account-withdrawl-methods button[type="submit"]')];
            this.paymentAmount = withdrawForm.querySelector("input[name=Amount]");
            if (!this.paymentAmount) {
                return;
            }
            this.paymentMethods = [...document.querySelectorAll("#account-withdrawl-methods .payment-methods")];
            this.activePaymentMethod = "";
            this.paymentMethods.map(paymentMethod => {
                paymentMethod.onclick = (el) => {
                    if (!el.currentTarget.classList.contains('active')) {
                        this.paymentMethods.map(pm => utility.removeClass(pm, "active")) && utility.addClass(el.currentTarget, "active");
                        this.activePaymentMethod = el.currentTarget;
                    }
                }
            });

            //force click the first withdrawl method
            this.paymentMethods[0].click();

            withdrawForm.onsubmit = () => {
                this.withdrawForm.querySelector("input[name=PaymentMethodId]").value = this.activePaymentMethod.dataset.paymentmethod;
                this.withdrawForm.querySelector("input[name=CustomerPaymentMethodId]").value = this.activePaymentMethod.dataset.value;
                this.submitWithdraw();
                return false;
            };

            if (this.otherLabel) {
                this.detectValue(document.querySelector("#withdraw_funds_1"));
            }
        }

        submitWithdraw() {
            var form = this.withdrawForm;
            var thisSubmitButtons = this.submitButtons;
            var withdrawSuccessFunction = this.handleWithdrawSuccess;
            var withdrawFailedFunction = this.handleWithdrawFailed;
            const processType = this.withdrawForm.querySelector("input[name='ProcessType']").value;
            const ajaxOptions = {
                url: "/api/web/account/perform-withdraw",
                method: "POST",
                data: utility.getFormData(form),
                success: function(e) {
                    utility.removeFormInputErrors(form);
                    var result = JSON.parse(e.target.responseText);
                    if (result.result === "S") {
                        if (processType === "W") {
                            withdrawSuccessFunction(result.reference);
                        }
                        else {
                            thisSubmitButtons.map(submitButton => utility.enableButton(submitButton));
                            utility.showNotificationPopup({
                                title: "Success",
                                centreContent: true,
                                content: "Your withdrawal method has been saved.",
                                hideCloseIcon: true,
                                button: {
                                    url: "/account/withdraw"
                                }
                            });
                        }
                    }
                    else {
                        thisSubmitButtons.map(submitButton => utility.enableButton(submitButton));
                        withdrawFailedFunction(result, form);
                    }
                },
                error: function() {
                    thisSubmitButtons.map(submitButton => utility.enableButton(submitButton));
                    utility.removeFormInputErrors(form);
                }
            };
            thisSubmitButtons.map(submitButton => utility.disableButton(submitButton));
            utility.ajaxRequest(ajaxOptions);
        }

        handleWithdrawFailed(result, form) {
            if (result.result == "R") {
                window.location.href = result.location;
            }
            else if (result.result == "L") {
                utility.showLoginPopup();
            }
            else if (result.result == "F") {
                result.fieldErrors.map(error => {
                    utility.addFormInputError(form, error.Name, error.Error);
                });
            }
            else if (result.result == "E") {
                utility.showNotificationPopup({
                    title: "Error",
                    centreContent: true,
                    content: `${result.message}`
                });
            }
            else {
                utility.showNotificationPopup({
                    title: "Error",
                    content: "An unknown error has occurred"
                });
            }
        }

        handleWithdrawSuccess(reference) {
            const ajaxOptions = {
                url: "/api/web/account/withdraw-success?reference=" + reference,
                method: "GET",
                success: function(e) {
                    utility.showContentPopup(e.target.responseText);
                },
                always: function() {
                    utility.enableButton(document.querySelector("#account--change-password-form button[type=submit]"));
                }
            };
            utility.ajaxRequest(ajaxOptions);
        }

        detectValue(option) {
            if (option.value == 'other') {
                this.otherValues();
                return;
            }
            this.otherLabel.classList.remove('active');
            this.changeValues(option.value);
        }

        otherValues() {
            if (this.otherInput.value) {
                this.otherInput.value = '';
            }
            this.changeValues('0.00');
            this.otherLabel.classList.add('active');
            this.otherInput.oninput = () => {
                let otherValue = Number(this.otherInput.value).toFixed(2);
                if(this.otherInput.value == '') {
                    otherValue = '0.00';
                }
                this.changeValues(otherValue);
            };
        }

        changeValues(value) {
            this.paymentAmount.value = value;
            this.submitButtons.map(submitButton => {
                submitButton.textContent = `Withdraw $${value}`;
            });    
        }
    },

      resultExpandClick: function () {
          [...document.querySelectorAll("#account-withdrawl-methods .withdraw-expand")].map(el => {
            const details = el.nextElementSibling;
            if (details && details.classList.contains("payment-content")) {
                el.onclick = () => {
                    [...document.querySelectorAll("#account-withdrawl-methods .withdraw-expand")].map(el => {
                        utility.removeClass(el, "active");
                        if (el.nextElementSibling) {
                            el.nextElementSibling.style.maxHeight = 0;
                        }
                    });
                    utility.toggleClass(el, "active");
                    if (el.classList.contains('active')) {
                        details.style.maxHeight = `${details.scrollHeight}px`;
                    }
                    else {
                        details.style.maxHeight = 0;
                    }
                };
            }
        });
    }
};

export default withdrawFunds


// WEBPACK FOOTER //
// ./assets/src/js/classes/withdrawFunds.js